export default __webpack_public_path__ + "static/media/aboutBgDescription.9500552d.png";